import { PageMetadata } from '../../pages/types/page.types';

export type Collection = {
  structure?: DisplayedCollectionSection[];
  id: string;
  title: string;
  createdAt: number;
  updatedAt: number;
  archivedAt: number;
  isPublic?: boolean;
  isFavourite?: boolean;
  tags?: string[];
  isSample?: boolean;
  sections?: Section[];
  description?: string;
};

export type Section = {
  id: string;
  title: string;
  orderNumber: number;
  archivedAt?: number;
};

export type DisplayedCollectionSection = {
  section: Section & { pages: PageMetadata[] };
};

export enum CollectionFilter {
  All = 'All',
  Favourites = 'Favourites',
  Public = 'Public',
  Archived = 'Archived',
  Tagged = 'Tagged',
}
